import { render, staticRenderFns } from "./ComponentsList.vue?vue&type=template&id=4ad9eda7"
import script from "./ComponentsList.vue?vue&type=script&lang=js"
export * from "./ComponentsList.vue?vue&type=script&lang=js"
import style0 from "./ComponentsList.vue?vue&type=style&index=0&id=4ad9eda7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports